   import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import AllUsersList from '../ChatApp/AllUsersList'; 
import ChatApp from '../ChatApp/ChatApp';
import UserSearchBox from '../../SchoolDashApp/UserDetails/UserSearchBox';
import ChatNotificationModal from '../ChatApp/ChatNotificationModal';
import NotificationIcon from '../ChatApp/NotificationIcon';
import AdministrativeSalary from '../../SchoolDashApp/AdministrativeSalary';
import DeanDashboard from '../../NewDashboard/DeanDashboard';
import LoginAuthentication from '../../pages/LoginAuthentication';
import TeacherAttendanceScanner from '../../NewDashboard/SmartIDCardScaner/TeacherAttendanceScanner';

import UserDetailsPage from '../../SchoolDashApp/UserDetails/UserDetailsPage';
import Navbar from '../Navbar';
import Header from '../../SchoolDashApp/Header';
import SchoolFeesData from '../../SchoolDashApp/SchoolFeesData';
import PrincipalMessagePage from '../../ViewPages/PrincipalMessagePage';
import CampusPage from '../../ViewPages/CampusPage';
import LibraryPage from '../../ViewPages/LibraryPage'; 
import SchoolAnnouncement from '../../ViewPages/SchoolAnnouncement';
import ReportCard from '../../NewDashboard/ReportCard';
import ParentsDashboard from '../../Dashboard/ParentsDashboard';
import StuDash from '../../Dashboard/StuDash';
import TeacherDataForm from '../../pages/Teachers/TeacherDataForm';
import StudentGrades from '../../Dashboard/StudentGrades';
import ReceiptPayment from '../../SchoolDashApp/Receipt/ReceiptPayment';

import Notifications from '../../Dashboard/Notifications';
import RegisterDashboard from '../../NewDashboard/RegisterDashboard';

import ForgotPassword from '../auth/ForgotPassword';
import ResetPassword from '../auth/ResetPassword';
import VerifyCode from '../auth/VerifyCode';

import PaymentList from '../../SchoolDashApp/Receipt/PaymentList';
import FinancialPaymentRecord from '../../SchoolDashApp/FinancialPaymentRecord';
import PeriodReport from '../../pages/Reportcard/PeriodReport';
import Schedule from '../../pages/Schedule/Schedule';
import SchedulePage from '../../pages/Schedule/SchedulePage';
import SchedulePageTrack from '../../pages/Schedule/SchedulePageTrack';
import AttendanceRecord from '../../pages/Attendance/AttendanceRecord';
import AttendanceData from '../../pages/Attendance/AttendanceData';

import EllipsisLoader from '../../SchoolDashApp/Loader/EllipsisLoader';
import FeesBalances from '../../pages/Students/FeesBalances';
import GradesPerformance from '../../pages/Students/GradesPerformance';
import AddClass from '../../pages/Students/AddClass';
import AddSubject from '../../pages/Students/AddSubject';
import CreateDivision from '../../pages/Students/CreateDivision';
import Register from '../../pages/Register';
import HomeHeader from '../../ViewPages/HomeHeader';
import Login from '../../pages/Login';
import Home from '../../ViewPages/Home';
import SignUp from '../../pages/SignUp';
import UsersProfile from '../../Dashboard/UsersProfile';
import SubjectFormModal from '../../SchoolDashApp/Class/Subjects/SubjectFormModal';
import AdminDashboard from '../../SchoolDashApp/AdminDashboard';

import StudentsAdmission from '../../SchoolDashApp/StudentsAdmission';
import TeacherSubjectData from '../../pages/Teachers/TeacherSubjectData';
import TeacherDashboard from '../../Dashboard/TeacherDashboard';
import StudentDashboard from '../../Dashboard/StudentDashboard';
import MateriaUiDasTest from '../../pages/MateriaUiDasTest';
import StudentsList from '../../pages/Students/StudentsList';
import ClassViewList from '../../SchoolDashApp/Class/ClassViewList';
import GradeClassCount from '../../SchoolDashApp/Class/GradeClassCount';
import SubjectViewList from '../../SchoolDashApp/Class/Subjects/SubjectViewList';
import SubjectCountView from '../../SchoolDashApp/Class/Subjects/SubjectCountView';
import DivisionList from '../../SchoolDashApp/Division/DivisionList';
import ProtectedRoute from '../../pages/ProtectedRoute';
import GradeDistribution from '../../pages/Reportcard/GradeDistribution';
import StudentInfoCard from '../../pages/Students/StudentInfoCard';
import StudentPerformanceChart from '../../pages/Students/StudentPerformanceChart';
import Payroll from '../../pages/Teachers/Payroll';
import MonthlyPayrollSummary from '../../pages/Teachers/MonthlyPayrollSummary';
import SupportStaff from '../../pages/Teachers/SupportStaff';
import SalaryAdvance from '../../pages/Teachers/SalaryAdvance';
import PostAssignment from '../../pages/Teachers/PostAssignment';
import AssignmentView from '../../pages/Teachers/AssignmentView';

import NewVpiDashboard from '../../NewDashboard/NewVpiDashboard';

import VpaDashboard from '../../SchoolDashApp/VpaDashboard';
import NewVpaDashboard from '../../NewDashboard/NewVpaDashboard';
import ITPersonalDashboard from '../../SchoolDashApp/ITPersonalDashboard';
import NewAdminDashboard from '../../NewDashboard/NewAdminDashboard';
import SelectAcademyYear from '../../NewDashboard/AcademyYearSelection/SelectAcademyYear';
import Secure from '../../NewDashboard/NewStudents/AdmissionForm/Secure';
import AdmissionOfficialDashboard from '../../NewDashboard/AdmissionOfficialDashboard';
import ProprietorDashboard from '../../NewDashboard/ProprietorDashboard';
import PrincipalDashboard from '../../NewDashboard/PrincipalDashboard';
import NewBusinessManagerDashboard from '../../NewDashboard/NewBusinessManagerDashboard';


const AppRoutes = () => {
  const location = useLocation();

  const hideNavbarRoutes = [
    // '/admin-dashboard',  
    '/newAdminDashboard',
    '/admissionOfficialDashboard',
    '/principalDashboard',
    '/proprietorDashboard',
     '/forgotPassword',
      '/resetPassword',
       '/verifyCode', 
       '/loginAuthentication',
       '/teacherAttendanceScanner',
    '/login',

    '/principalDashboard',
    '/teacher-dashboard',
    '/student-dashboard',
    '/parentsDashboard',
    '/chatApp',
    '/registerDashboard',
    '/businessManagerDashboard',
    '/vpiDashboard',
    '/vpaDashboard',
    '/deanDashboard',
    '/tTPersonalDashboard'
  ];

  const shouldShowNavbar = !hideNavbarRoutes.includes(location.pathname);

  return (
    <>
      {shouldShowNavbar && <Navbar />}
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} /> 
        
      
        {/* <Route path="/" element={<NewAdminDashboard />} />  */}
        <Route path="/register" element={<Register />} />
        <Route path="/ellipsisLoader" element={<EllipsisLoader />} />
        <Route path="/signUp" element={<SignUp />} /> 
        <Route path="/login" element={<Login />} />
        <Route path="/loginAuthentication" element={<LoginAuthentication />} /> 
        <Route path="/teacherAttendanceScanner" element={<TeacherAttendanceScanner />} />
        
        <Route path="/principalMessagePage" element={<PrincipalMessagePage />} />
        <Route path="/campusPage" element={<CampusPage />} />
        <Route path="/libraryPage" element={<LibraryPage />} />
        {/* <Route path="/usersProfile" element={<UsersProfile />} /> */}
        <Route path="/schoolFeesData" element={<ProtectedRoute><SchoolFeesData /></ProtectedRoute>} />
        <Route path="/userDetailsPage" element={<ProtectedRoute><UserDetailsPage /></ProtectedRoute>} />
        <Route path="/userSearchBox" element={<ProtectedRoute><UserSearchBox /></ProtectedRoute>} />
        <Route path="/iTPersonalDashboard" element={<ProtectedRoute><ITPersonalDashboard /></ProtectedRoute>} />

        <Route path="/student-secure/:id" element={<Secure />} />

        


        {/* Protected Routes */}
        {/* <Route path="/chatModal" element={<ProtectedRoute><ChatModal /></ProtectedRoute>} /> */}
        <Route path="/receiptPayment" element={<ProtectedRoute><ReceiptPayment /></ProtectedRoute>} />
        <Route path="/deanDashboard" element={<ProtectedRoute><DeanDashboard /></ProtectedRoute>} />
        <Route path="/schedule" element={<ProtectedRoute><Schedule /></ProtectedRoute>} />
        <Route path="/schedulePage" element={<ProtectedRoute><SchedulePage /></ProtectedRoute>} />
        <Route path="/schedulePageTrack" element={<ProtectedRoute><SchedulePageTrack /></ProtectedRoute>} />
        <Route path="/gradeDistribution" element={<ProtectedRoute><GradeDistribution /></ProtectedRoute>} />
        <Route path="/periodReport" element={<ProtectedRoute><PeriodReport /></ProtectedRoute>} />
        <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
        <Route path="/reportCard" element={<ProtectedRoute><ReportCard /></ProtectedRoute>} />
        <Route path="/stuDash" element={<ProtectedRoute><StuDash /></ProtectedRoute>} />
        <Route path="/teacherDataForm" element={<ProtectedRoute><TeacherDataForm /></ProtectedRoute>} />
        <Route path="/studentGrades" element={<ProtectedRoute><StudentGrades /></ProtectedRoute>} />
        <Route path="/attendanceData" element={<ProtectedRoute><AttendanceData /></ProtectedRoute>} />
        <Route path="/attendanceRecord" element={<ProtectedRoute><AttendanceRecord /></ProtectedRoute>} />
        <Route path="/paymentList" element={<ProtectedRoute><PaymentList /></ProtectedRoute>} />
        <Route path="/header" element={<ProtectedRoute><Header /></ProtectedRoute>} />
        <Route path="/subjectFormModal" element={<ProtectedRoute><SubjectFormModal /></ProtectedRoute>} />
        

        <Route path="/admin-dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} /> 
        <Route path="/newAdminDashboard" element={<ProtectedRoute><NewAdminDashboard /></ProtectedRoute>} />
        <Route path="/admissionOfficialDashboard" element={<ProtectedRoute><AdmissionOfficialDashboard /></ProtectedRoute>} />

       

        <Route path="/principalDashboard" element={<ProtectedRoute><PrincipalDashboard /></ProtectedRoute>} />
        <Route path="/proprietorDashboard" element={<ProtectedRoute><ProprietorDashboard /></ProtectedRoute>} />
        <Route path="/registerDashboard" element={<ProtectedRoute><RegisterDashboard /></ProtectedRoute>} />
        <Route path="/studentsAdmission" element={<ProtectedRoute><StudentsAdmission /></ProtectedRoute>} />
        <Route path="/financialPaymentRecord" element={<ProtectedRoute><FinancialPaymentRecord /></ProtectedRoute>} />
        <Route path="/classViewList" element={<ProtectedRoute><ClassViewList /></ProtectedRoute>} />
        <Route path="/divisionList" element={<ProtectedRoute><DivisionList /></ProtectedRoute>} />
        <Route path="/subjectViewList" element={<ProtectedRoute><SubjectViewList /></ProtectedRoute>} />
        <Route path="/feesBalances" element={<ProtectedRoute><FeesBalances /></ProtectedRoute>} />
        <Route path="/gradesPerformance" element={<ProtectedRoute><GradesPerformance /></ProtectedRoute>} />

        <Route path="/addClass" element={<ProtectedRoute><AddClass /></ProtectedRoute>} />
        <Route path="/addSubject" element={<ProtectedRoute><AddSubject /></ProtectedRoute>} />
        <Route path="/createDivision" element={<ProtectedRoute><CreateDivision /></ProtectedRoute>} />
        <Route path="/administrativeSalary" element={<ProtectedRoute><AdministrativeSalary /></ProtectedRoute>} />

        {/* Unprotected routes that may still need role check */}
       <Route path="/teacher-dashboard" element={<ProtectedRoute><TeacherDashboard /></ProtectedRoute>} />
       <Route path="/student-dashboard" element={<ProtectedRoute><StudentDashboard /></ProtectedRoute>} />
       <Route path="/parentsDashboard" element={<ProtectedRoute><ParentsDashboard /></ProtectedRoute>} />
       <Route path="/businessManagerDashboard" element={<ProtectedRoute><NewBusinessManagerDashboard /></ProtectedRoute>} />
       <Route path="/studentInfoCard" element={<ProtectedRoute><StudentInfoCard /></ProtectedRoute>} />
       <Route path="/vpiDashboard" element={<ProtectedRoute><NewVpiDashboard /></ProtectedRoute>} />
       <Route path="/vpaDashboard" element={<ProtectedRoute><NewVpaDashboard /></ProtectedRoute>} />
       <Route path="/studentPerformanceChart" element={<ProtectedRoute><StudentPerformanceChart /></ProtectedRoute>} /> 
      <Route path="/payroll" element={<ProtectedRoute><Payroll /></ProtectedRoute>} /> 
      <Route path="/monthlyPayrollSummary" element={<ProtectedRoute><MonthlyPayrollSummary /></ProtectedRoute>} /> 
      <Route path="/supportStaff" element={<ProtectedRoute><SupportStaff /></ProtectedRoute>} /> 
      <Route path="/salaryAdvance" element={<ProtectedRoute><SalaryAdvance /></ProtectedRoute>} />
      <Route path="/postAssignment" element={<ProtectedRoute><PostAssignment /></ProtectedRoute>} />  
      <Route path="/assignmentView" element={<ProtectedRoute><AssignmentView /></ProtectedRoute>} />  
      <Route path="/chatApp" element={<ProtectedRoute><ChatApp /></ProtectedRoute>} />
      <Route path="/chatNotificationModal" element={<ProtectedRoute><ChatNotificationModal /></ProtectedRoute>} />
      <Route path="/notificationIcon" element={<ProtectedRoute><NotificationIcon /></ProtectedRoute>} />
      <Route path="/allUsersList" element={<ProtectedRoute><AllUsersList /></ProtectedRoute>} /> 
      <Route path="/selectAcademyYear" element={<ProtectedRoute><SelectAcademyYear /></ProtectedRoute>} />
   
        <Route path="/schoolAnnouncement" element={<SchoolAnnouncement />} />
        <Route path="/homeHeader" element={<HomeHeader />} />
        <Route path="/materiaUiDasTest" element={<MateriaUiDasTest />} />
        <Route path="/studentsList" element={<StudentsList />} />
        <Route path="/gradeClassCount" element={<GradeClassCount />} />
        <Route path="/subjectCountView" element={<SubjectCountView />} />

        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/resetPassword" element={<ResetPassword />} />
        <Route path="/verifyCode" element={<VerifyCode />} />

      </Routes>
    </>
);
};

export default AppRoutes;

